import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRightIcon, CalendarIcon } from "lucide-react";
import { images } from "../../data/home";
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const reduce = useReducedMotion();
  const fade = (delay: number) => reduce ? {} : {
    initial: {
      opacity: 0,
      y: 12
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      delay,
      ease
    }
  };
  return <section className="px-5 pb-16 pt-14 md:px-8 md:pb-24 md:pt-20" data-id="element-107" data-mp="5oxigfabrklk">
      <div className="mx-auto max-w-5xl text-center" data-id="element-108" data-mp="5rtge3m6a9a0">
        <motion.h1 {...fade(0)} className="text-[44px] font-semibold leading-[1.02] tracking-tightest sm:text-6xl md:text-[84px]" data-id="element-109" data-mp="r5h6unsim4p">
          Des conseils personnalisés au service de vos placements
        </motion.h1>
        <motion.p {...fade(0.06)} className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted md:text-xl" data-id="element-110" data-mp="1v20xyk94p7ik">
          Cabinet indépendant de conseil en investissement financier. Nous sélectionnons
          pour vous les meilleurs placements et suivons votre patrimoine dans la durée.
        </motion.p>
        <motion.div {...fade(0.12)} className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-5" data-id="element-111" data-mp="1cz7yx259mzw4">
          <a href="#contact" className="whitespace-nowrap rounded-full bg-ink px-7 py-4 text-[17px] font-medium text-canvas transition-transform duration-150 active:scale-[0.97]" data-id="element-112" data-mp="1hz2o919e7hf2">
            Réserver un audit gratuit
          </a>
          <a href="#placements" className="group flex items-center gap-2 whitespace-nowrap px-3 py-4 text-[17px] font-medium" data-id="element-113" data-mp="1vwhiqkei6fdw">
            Découvrir nos placements
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-114" data-mp="2ok50zssawtxd" />
          </a>
        </motion.div>
      </div>

      <motion.div {...reduce ? {} : {
      initial: {
        opacity: 0,
        y: 20
      },
      animate: {
        opacity: 1,
        y: 0
      },
      transition: {
        duration: 0.3,
        delay: 0.18,
        ease
      }
    }} className="relative mx-auto mt-14 max-w-7xl md:mt-20" data-id="element-115" data-mp="336aqr1723p0t">
        <div className="overflow-hidden rounded-[28px] bg-surface md:rounded-[36px]" data-id="element-116" data-mp="2paykpxngac4l">
          <img src={images.hero} alt="Bureau du cabinet Le Nouveau Placement, lumière naturelle sur une table en chêne" className="aspect-[4/3] w-full object-cover sm:aspect-[16/9] lg:aspect-[21/9]" data-id="element-117" data-mp="2kau5eaya3nfy" />
        </div>

        <PortfolioCard data-id="element-118" data-mp="26j5rc24gyowc" />

        <div className="absolute right-6 top-6 hidden items-center gap-3 rounded-2xl bg-canvas/95 py-3 pl-3 pr-5 shadow-[0_8px_30px_rgba(0,0,0,0.08)] backdrop-blur md:flex lg:right-10 lg:top-10" data-id="element-119" data-mp="26jpblphldpdj">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-surface" data-id="element-120" data-mp="1wkgiszygqgsr">
            <CalendarIcon className="h-5 w-5" aria-hidden="true" data-id="element-121" data-mp="c1e57zv3wz2d" />
          </span>
          <div className="text-left" data-id="element-122" data-mp="gzxti6x6amxw">
            <p className="text-sm font-semibold" data-id="element-123" data-mp="h33g9fibxcqg">Point annuel avec Quentin</p>
            <p className="text-sm text-muted" data-id="element-124" data-mp="m0lfufagifls">Jeudi 16 oct. · 10h00</p>
          </div>
        </div>
      </motion.div>
    </section>;
}
function PortfolioCard() {
  return <div className="mx-auto -mt-16 w-[88%] max-w-sm rounded-3xl bg-canvas p-6 text-left shadow-[0_12px_40px_rgba(0,0,0,0.10)] md:absolute md:bottom-10 md:left-10 md:mt-0 md:w-80 lg:bottom-12 lg:left-12" data-id="element-125" data-mp="3phvb6vy0qjbj">
      <p className="text-sm font-medium text-muted" data-id="element-126" data-mp="2b1l28r7f7wr">Mon patrimoine financier</p>
      <p className="mt-1 text-[32px] font-semibold tracking-tight" data-id="element-127" data-mp="73cjf76aqln7">248 560 €</p>
      <p className="mt-1 text-sm font-medium text-gain" data-id="element-128" data-mp="36qayl3ea6ljr">+6,4 % sur 12 mois</p>
      <svg viewBox="0 0 280 64" className="mt-4 h-16 w-full" aria-hidden="true" data-id="element-129" data-mp="36o84a763i698">
        <path d="M0 52 L28 48 L56 50 L84 40 L112 42 L140 32 L168 34 L196 22 L224 26 L252 14 L280 8" fill="none" stroke="#1F7A4D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-130" data-mp="3aq37jh7l6tpn" />
      </svg>
      <div className="mt-3 flex justify-between text-xs text-muted" data-id="element-131" data-mp="31e5qfz1s9uj2">
        <span data-id="element-132" data-mp="2wmnq9d7l3xz5">Oct. 2025</span>
        <span data-id="element-133" data-mp="2wlclpb6bem6z">Oct. 2026</span>
      </div>
    </div>;
}